import { createReducer } from '@reduxjs/toolkit';

import { dismiss, flash, remove } from './actions';

export default createReducer([], {
  [flash]: (messages, { payload: newMessage }) => messages.concat(newMessage),
  [dismiss]: (messages, { payload: { id } }) => {
    const msg = messages.find(ea => ea.id === id) || {};
    msg.hidden = true;
  },
  [remove]: (messages, { payload: { id } }) =>
    messages.filter(message => message.id !== id),
});
